import { MenuItem, Typography } from "@mui/material";
import { IoCheckboxOutline, IoSquareOutline } from "react-icons/io5";
import {
  ALL_EVENT_TYPES,
  EVENT_TYPE_OPTIONS,
  isAllEventTypes,
  sanitizeEventTypes,
} from "./eventTypes";
import type { EventType } from "./eventTypes";

type Props = {
  value: EventType[];
  onChange: (next: EventType[]) => void;
};

/**
 * "Show" section of the dashboard funnel menu (table, calendar and overview):
 * which stages of a show to list. Same look as the status options above it.
 * Everything is the default; the list can never end up empty.
 */
export default function EventTypeFilterSection({ value, onChange }: Props) {
  const selected = sanitizeEventTypes(value);
  const everything = isAllEventTypes(selected);

  const toggle = (t: EventType) => {
    const on = selected.includes(t);
    if (on && selected.length === 1) return;
    onChange(on ? selected.filter((x) => x !== t) : [...selected, t]);
  };

  const rows: Array<{ key: string; label: string; checked: boolean; onClick: () => void }> = [
    {
      key: "everything",
      label: "Everything",
      checked: everything,
      onClick: () => onChange([...ALL_EVENT_TYPES]),
    },
    ...EVENT_TYPE_OPTIONS.map((o) => ({
      key: o.value,
      label: o.label,
      checked: selected.includes(o.value),
      onClick: () => toggle(o.value),
    })),
  ];

  return (
    <>
      {rows.map((row) => (
        <MenuItem
          key={row.key}
          sx={{ display: "flex", alignItems: "center", gap: "1rem" }}
          onClick={(e) => {
            row.onClick();
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {row.checked ? <IoCheckboxOutline size={22} /> : <IoSquareOutline size={22} />}
          <Typography>{row.label}</Typography>
        </MenuItem>
      ))}
    </>
  );
}
